import React, { useEffect } from "react";
import "./aboutHistory.scss";
import { useNavigate, useParams } from "react-router-dom";

const showConsole = true;

export default function AboutHistory() {
    const { page } = useParams();
    const navigate = useNavigate();
    showConsole && page && console.log("page:", page);

    function CardHistory(params) {
        let { title, memo, color, align } = params;
        !align && (align = "start");
        !color && (color = "brown");
        return (
            <div className="col px-4 mt-4 mb-3">
                <div id="card2521" class={`card text-${align} border-0`}>
                    <div class="card-title">
                        {align === "start" ? (
                            <h2 style={{ borderBottom: `3px solid ${color}` }}>
                                <span
                                    className="dot"
                                    style={{ backgroundColor: `${color}` }}
                                ></span>
                                {title}
                            </h2>
                        ) : (
                            <h2 style={{ borderBottom: `3px solid ${color}` }}>
                                {title}
                                <span
                                    className="dot"
                                    style={{ backgroundColor: `${color}` }}
                                ></span>
                            </h2>
                        )}
                    </div>
                    <div class="card-body">
                        {memo}
                        {/* <p class="card-text">วันที่....</p> */}
                    </div>
                </div>
            </div>
        );
    }

    function CardVision(params) {
        let { title, memo } = params;
        // console.log("memo:", memo);
        return (
            <>
                <h1 className="mt-5">{title}</h1>
                <div className="card-body p-4 mb-3">
                    {typeof memo === "object" ? (
                        <ol>
                            {memo.map((item) => (
                                <li style={{ marginBottom: "14px" }}>
                                    {item.list}
                                </li>
                            ))}
                        </ol>
                    ) : (
                        memo
                    )}
                </div>
            </>
        );
    }

    function CardOurDean(params) {
        const { name, lastname, since, img } = params;

        return (
            <div className="ourDean">
                {/* <div className="image"> */}
                <img src={img} alt={name} className="img-fluid mb-3" />
                {/* </div> */}
                <div className="name">
                    {name}
                    <span>{lastname}</span>
                </div>
                <div className="since">{since}</div>
            </div>
        );
    }

    const CardAddress = (params) => {
        const {
            title,
            address,
            address2,
            address3,
            tel,
            fax,
            email,
            facebook,
        } = params;
        return (
            <div className="col cardAddress">
                <h2>{title}</h2>
                {address && <p>{address}</p>}
                {address2 && <p>{address2}</p>}
                {address3 && <p>{address3}</p>}
                {tel && (
                    <p>
                        TEL: {tel}
                        {fax && (
                            <span style={{ marginLeft: "2em" }}>
                                FAX: {fax}
                            </span>
                        )}
                    </p>
                )}
                {email && (
                    <p>
                        EMAIL: <a href={`mailto:${email}`}>{email}</a>
                    </p>
                )}
                {facebook && (
                    <p>
                        Facebook:{" "}
                        <a
                            href={`https://www.facebook.com/${facebook}`}
                            target="_blank"
                            rel="noreferrer"
                        >
                            fb.com/{facebook}
                        </a>
                    </p>
                )}
            </div>
        );
    };

    useEffect(() => {}, []);

    const pageHistory = () => {
        if (!page || page === "about") {
            return (
                <>
                    <div id="about">
                        <h1>ความเป็นมา</h1>
                        {/* <p>
                            คณะสถาปัตยกรรมศาสตร์และการออกแบบสิ่งแวดล้อม
                            มหาวิทยาลัยแม่โจ้
                            เดิมเป็นภาควิชาตกแต่งบริเวณและอนุรักษ์สิ่งแวดล้อม
                            ในปี พ.ศ. 2521 และได้รับการสถาปนาเป็นคณะฯ
                            โดยมติคณะกรรมการสภามหาวิทยาลัยแม่โจ้ ในวันที่ 5
                            พฤศจิกายน พ.ศ. 2549
                            ปัจจบันเปิดให้มีการจัดการเรียนการสอนในระดับหลักสูตรปริญญาตรี
                            จำนวน 3 หลักสูตร ได้แก่ หลักสูตรสาขาสถาปัตยกรรม (5
                            ปี), หลักสูตรสาขาภูมิสถาปัตยกรรม (5 ปี)
                            และหลักสูตรสาขาเทคโนโลยีภูมิทัศน์ (4 ปี) หลักสูตร
                            โดยเป็นการเปิดสอนหลักสูตรภูมิสถาปัตยกรรมแห่งแรกของภาคเหนือ
                            ทั้งนี้ คณาจารย์ 3 ผู้บุกเบิกสร้างหลักสูตรขึ้นมา
                            ได้แก่ อาจารย์สมพร ยกตรี (แม่โจ้รุ่น 20) อาจารย์โสภณ
                            มงคลวัจน์ (พืชสวน แม่โจ้รุ่น 36) และ รศ.ศิริชัย
                            หงษ์วิทยากร (Master in Landscape architecture,
                            University of Michigan) ปัจจุบัน
                            คณะสถาปัตยกรรมศาสตร์และการออกแบบสิ่งแวดล้อม
                            มหาวิทยาลัยแม่โจ้เปิดสอนทั้งหมด 5 หลักสูตร
                            โดยเป็นคณะที่จัดการเรียนการสอนทางด้านสถาปัตยกรรมที่มีหลักสูตรมากที่สุดในภาคเหนือ
                            ประกอบด้วยหลักสูตรปริญญาตรีจำนวน 3 หลักสูตร
                            หลักสูตรระดับปริญญาโทจำนวน 1 หลักสูตร
                            และหลักสูตรระดับปริญญาเอกจำนวน 1 หลักสูตร
                        </p> */}
                        <p>
                            คณะสถาปัตยกรรมศาสตร์และการออกแบบสิ่งแวดล้อม มหาวิทยาลัยแม่โจ้ แต่เดิม เมื่อปี 2521 จัดตั้งเป็นภาควิชาตกแต่งบริเวณและอนุรักษ์สิ่งแวดล้อม และในปี 2527 ได้เปลี่ยนชื่อเป็นภาควิชาภูมิทัศน์และอนุรักษ์สิ่งแวดล้อม สังกัดคณะผลิตกรรมการเกษตร และเริ่มเปิดรับนักศึกษาระดับปริญญาตรีหลักสูตร 2 ปี สาขาวิชาเทคโนโลยีภูมิทัศน์ (Landscape Technology) จากนั้นในปี 2538 เปิดรับนักศึกษาระดับปริญญาตรีหลักสูตร 5 ปี สาขาวิชาภูมิสถาปัตยกรรม (Landscape Architecture) ภายหลังได้ยกฐานะเป็นหน่วยงานระดับคณะ โดยมติคณะกรรมการสภามหาวิทยาลัย เมื่อวันที่ 5 พฤศจิกายน 2549 และในปี 2550 เปิดรับนักศึกษาระดับปริญญาตรี หลักสูตร 4 ปี สาขาวิชาเทคโนโลยีภูมิทัศน์ ต่อมา ในปี 2552 เปิดรับนักศึกษาระดับปริญญาตรี หลักสูตร 5 ปี สาขาวิชาสถาปัตยกรรม และในปี 2553 เปิดรับนักศึกษาหลักสูตรระดับบัณฑิตศึกษา สาขาวิชาการออกแบบ และวางแผนสิ่งแวดล้อม ต่อมา ในปี 2558 เปิดรับนักศึกษาหลักสูตรระดับบัณฑิตศึกษา สาขาวิชาการวางผังเมืองและสภาพแวดล้อม และ ในปี 2567 เปิดรับนักศึกษาหลักสูตรระดับบัณฑิตศึกษา สาขาวิชานวัตกรรมการออกแบบเพื่อความยั่งยืน
                        </p>
                        <p>
                            ปัจจุบันมีหลักสูตรที่เปิดรับนักศึกษาดังนี้
                            <div className="ms-5 fw-bold">ระดับบัณฑิตศึกษา</div>
                            <ol className="ms-5">
                                <li>
                                    หลักสูตรปรัชญาดุษฎีบัณฑิต
                                    สาขาวิชานวัตกรรมการออกแบบเพื่อความยั่งยืน
                                    (Design Innovation for Sustainablity)
                                </li>
                                <li>
                                    หลักสูตรการวางแผนภาคและเมืองมหาบัณฑิต
                                    สาขาวิชาการวางผังเมืองและสภาพแวดล้อม
                                    (Environmental and Urban Planning)
                                </li>
                            </ol>
                            <div className="ms-5 fw-bold">ระดับปริญญาตรี</div>
                            <ol className="ms-5">
                                <li>
                                    หลักสูตรสถาปัตยกรรมศาสตรบัณฑิต
                                    สาขาวิชาสถาปัตยกรรม (Architecture)
                                </li>
                                <li>
                                    หลักสูตรภูมิสถาปัตยกรรมศาสตรบัณฑิต
                                    สาขาวิชาภูมิสถาปัตยกรรม (Landscape
                                    Architecture)
                                </li>
                                <li>
                                    หลักสูตรภูมิสถาปัตยกรรมศาสตรบัณฑิต
                                    สาขาวิชาเทคโนโลยีภูมิทัศน์ (Landscape
                                    Technology)
                                </li>
                            </ol>
                        </p>
                        {/* <p>
                            คณะสถาปัตยกรรมศาสตร์และการออกแบบสิ่งแวดล้อม ปี 2521
                            เป็นภาควิชาตกแต่งบริเวณและอนุรักษ์สิ่งแวดล้อม ปี
                            2527
                            เปลี่ยนชื่อเป็นภาควิชาภูมิทัศน์และอนุรักษ์สิ่งแวดล้อม
                            สังกัดคณะผลิตกรรมการเกษตร
                            และเริ่มเปิดรับนักศึกษาระดับปริญญาตรีหลักสูตร 2 ปี
                            สาขาวิชาเทคโนโลยีภูมิทัศน์ (Landscape Technology)
                            ในปี 2538 เปิดรับนักศึกษาระดับปริญญาตรีหลักสูตร 5 ปี
                            สาขาวิชาภูมิสถาปัตยกรรม (Landscape Architecture)
                            เริ่มเปิดรับนักศึกษาระดับปริญญาตรีหลักสูตร 2 ปี
                            สาขาวิชาเทคโนโลยีภูมิทัศน์ (Landscape Technology)
                            ในปี 2538 เปิดรับนักศึกษาระดับปริญญาตรีหลักสูตร 5 ปี
                            สาขาวิชาภูมิสถาปัตยกรรม (Landscape Architecture)
                            และได้ยกฐานะเป็นหน่วยงานระดับคณะ
                            โดยมติคณะกรรมการสภามหาวิทยาลัย เมื่อวันที่ 5
                            พฤศจิกายน 2549 ปีการศึกษา 2550
                            เปิดรับนักศึกษาระดับปริญญาตรี หลักสูตร 4 ปี
                            สาขาวิชาเทคโนโลยีภูมิทัศน์ ปีการศึกษา 2552
                            เปิดรับนักศึกษาระดับปริญญาตรี หลักสูตร 5 ปี
                            สาขาวิชาสถาปัตยกรรม ปีการศึกษา 2553
                            เปิดรับนักศึกษาหลักสูตรระดับบัณฑิตศึกษา
                            สาขาวิชาการออกแบบ และวางแผนสิ่งแวดล้อม ปีการศึกษา
                            2558 เปิดรับนักศึกษาหลักสูตรระดับบัณฑิตศึกษา
                            สาขาวิชาการวางผังเมืองและสภาพแวดล้อม ปีการศึกษา 2567
                            เปิดรับนักศึกษาหลักสูตรระดับบัณฑิตศึกษา
                            สาขาวิชานวัตกรรมการออกแบบเพื่อความยั่งยืน
                        </p> */}
                    </div>
                    <div id="history" className="">
                        <h1>ประวัติคณะฯ</h1>
                        <div className=" col-11 col-md-10 col-lg-10 col-xl-8 px-lg-5 px-2 align-content-center mx-auto">
                            <div className="row row-cols-1">
                                <CardHistory
                                    title="ปี พ.ศ. 2521"
                                    memo="จัดตั้งเป็นภาควิชาตกแต่งบริเวณและอนุรักษ์สิ่งแวดล้อม"
                                    color="#e0753f"
                                />
                                <CardHistory
                                    title="ปี พ.ศ. 2527"
                                    memo="เปลี่ยนชื่อเป็นภาควิชาภูมิทัศน์และอนุรักษ์สิ่งแวดล้อม สังกัดคณะผลิตกรรมการเกษตร และเริ่มเปิดรับนักศึกษาระดับปริญญาตรีหลักสูตร 2 ปี สาขาวิชาเทคโนโลยีภูมิทัศน์ (Landscape Technology)"
                                    color="#088cd9"
                                    align="end"
                                />
                                <CardHistory
                                    title="ปี พ.ศ. 2538"
                                    memo="เปิดรับนักศึกษาระดับปริญญาตรี หลักสูตร 5 ปี สาขาวิชาภูมิสถาปัตยกรรม (Landscape Architecture)"
                                    color="#295f98"
                                />
                                <CardHistory
                                    title="ปี พ.ศ. 2549"
                                    memo="ได้ยกฐานะเป็นหน่วยงานระดับคณะ โดยมติคณะกรรมการสภามหาวิทยาลัยแม่โจ้"
                                    color="#C96868"
                                    align="end"
                                />
                                <CardHistory
                                    title="ปี พ.ศ. 2550"
                                    memo="เปิดรับนักศึกษาระดับปริญญาตรี หลักสูตร 4 ปี สาขาวิชาเทคโนโลยีภูมิทัศน์ (Landscape Technology)"
                                    color="#705c53"
                                />
                                <CardHistory
                                    title="ปี พ.ศ. 2552"
                                    memo="เปิดรับนักศึกษาระดับปริญญาตรี หลักสูตร 5 ปี สาขาวิชาสถาปัตยกรรม (Architecture)"
                                    color="#A5B68D"
                                    align="end"
                                />
                                <CardHistory
                                    title="ปี พ.ศ. 2553"
                                    memo="เปิดรับนักศึกษาระดับปริญญาโท สาขาวิชาการออกแบบและวางแผนสิ่งแวดล้อม (Environmental Design and Planning)"
                                    color="#088cd9"
                                />
                                <CardHistory
                                    title="ปี พ.ศ. 2558"
                                    memo="เปิดรับนักศึกษาระดับปริญญาโท สาขาวิชาการวางผังเมืองและสภาพแวดล้อม (Environmental and Urban Planning)"
                                    color="#e0753f"
                                    align="end"
                                />
                                <CardHistory
                                    title="ปี พ.ศ. 2567"
                                    memo="เปิดรับนักศึกษาระดับปริญญาเอก สาขาวิชานวัตกรรมการออกแบบเพื่อความยั่งยืน (Design Innovation for Sustainablity)"
                                    color="#295f98"
                                />
                            </div>
                        </div>
                    </div>
                </>
            );
        } else if (page && page === "vision") {
            return (
                <div id="vision" className="">
                    {/* <h1>ประวัติคณะฯ</h1> */}
                    <div className=" col-12 col-md-10 px-md-5 px-2 align-content-center mx-auto">
                        <div className="row row-cols-1">
                            <CardVision
                                title="ปรัชญา"
                                memo="มุ่งมั่นพัฒนาบัณฑิตสู่ความเป็นนักออกแบบที่ดี
อุดมด้วยปัญญา อดทน สู้งาน มีคุณธรรม และจริยธรรม
เพื่อความเจริญ รุ่งเรืองวัฒนาของสังคมไทยที่มีการเกษตรเป็นฐานราก ที่ตระหนักภูมิสังคม"
                            />
                            <CardVision
                                title="วิสัยทัศน์"
                                memo="“ผู้นำด้านการออกแบบที่ดีในระดับสากล”"
                            />
                            <CardVision
                                title="พันธกิจ"
                                memo={[
                                    {
                                        list: "มุ่งพัฒนาวิชาการและวิชาชีพ (Research & Design)",
                                    },
                                    {
                                        list: "มุ่งพัฒนางานตามกรอบพันธกิจหลัก และงานยุทธศาสตร์ (MOC & SPO)",
                                    },
                                    {
                                        list: "มุ่งพัฒนาหลักสูตรในระบบ และหลักสูตรทางเลือก (Education & Learning)",
                                    },
                                    {
                                        list: "เสริมสร้างสภาพแวดล้อมให้เอื้อต่อการเรียนรู้ (Learning Space)",
                                    },
                                    {
                                        list: "สร้างคลังความรู้ทางวิชาการ และวิชาชีพ ด้านการออกแบบสิ่งแวดล้อม (Knowledge Tank)",
                                    },
                                ]}
                            />
                            <CardVision
                                title="วัตถุประสงค์"
                                memo={[
                                    {
                                        list: "เพื่อพัฒนาวิชาการและวิชาชีพ (Research & Design)",
                                    },
                                    {
                                        list: "เพื่อพัฒนางานตามกรอบพันธกิจหลัก และงานยุทธศาสตร์ (MOC & SPO)",
                                    },
                                    {
                                        list: "เพื่อพัฒนาหลักสูตรในระบบ และหลักสูตรทางเลือก (Education & Learning)",
                                    },
                                    {
                                        list: "เพื่อเสริมสร้างสภาพแวดล้อมให้เอื้อต่อการเรียนรู้ (Learning Space)",
                                    },
                                    {
                                        list: "เพื่อสร้างคลังความรู้ทางวิชาการ และวิชาชีพ ด้านการออกแบบสิ่งแวดล้อม (Knowledge Tank)",
                                    },
                                ]}
                            />
                        </div>
                    </div>
                </div>
            );
        } else if (page && page === "core") {
            return (
                <div id="core" className="">
                    {/* <h1>ประวัติคณะฯ</h1> */}
                    <div className=" col-12 col-md-10 px-md-5 px-2 align-content-center mx-auto">
                        <div className="row row-cols-1">
                            <CardVision
                                title="สีประจำคณะ"
                                memo="น้ำตาลทอง Aureus Brown หมายถึง ชื่อของต้นไม้สีทองซึ่งปลูกไว้ที่ด้านหน้าของอาคารปฏิบัติการภูมิทัศน์ฯ ซึ่งมีชื่อวิทยาศาสตร์ว่า Buhnia aureifolia K.& S.S. Larsen คำว่า aureifolia แปลว่า ใบไม้สีทอง มาจากคำว่า aureo (สี ทอง) +folia (ใบไม้) จึงนำคำว่า Aureus (เป็นคำ adj.) มาใช้เพื่อให้สื่อถึงสีของต้นไม้"
                            />
                            <CardVision
                                title="คำนิยม (Value)"
                                memo="“ตระหนักในสิ่งแวดล้อม - Environmental Awareness”"
                            />
                            <CardVision
                                title="คำขวัญ (Slogan)"
                                memo="“Where Art meets Science Where Design meets Environment”"
                            />
                            <CardVision
                                title="วัฒนธรรมองค์กร"
                                memo="“Think Global Act Local”"
                            />
                        </div>
                    </div>
                </div>
            );
        } else if (page && page === "ourdean") {
            return (
                <div id="core" className="">
                    <div className=" col-12 col-md-10 px-md-5 px-2 mb-4 align-content-center mx-auto">
                        <div className="row row-cols-1 text-center">
                            <h1 style={{ marginTop: "30px", textAlign:"start" }}>ทำเนียบคณบดี</h1>
                            <CardOurDean
                                name="อาจารย์ ดร.โชคอนันต์"
                                lastname="วาณิชย์เลิศธนาสาร"
                                since="ปี พ.ศ. 2563 - ปัจจุบัน"
                                img="https://www.mju.ac.th/th/images/chokarnan.jpg"
                            />
                            <CardOurDean
                                name="รองศาสตราจารย์ ดร.เกรียงศักดิ์"
                                lastname="ศรีเงินยวง"
                                since="ปี พ.ศ. 2559 - 2563"
                                img="https://arch.mju.ac.th/img/Personal/EP465.jpg"
                            />
                            <CardOurDean
                                name="อาจารย์ บรรจง"
                                lastname="สมบูรณ์ชัย"
                                since="ปี พ.ศ. 2555 - 2559"
                                img="https://arch.mju.ac.th/img/Personal/EP268.jpg"
                            />
                            <CardOurDean
                                name="รองศาสตราจารย์ ดร.เกรียงศักดิ์ "
                                lastname="ศรีเงินยวง"
                                since="ปี พ.ศ. 2551 - 2555"
                                img="https://arch.mju.ac.th/img/Personal/EP465.jpg"
                            />
                            <CardOurDean
                                name="รองศาสตราจารย์ ศิริชัย"
                                lastname="หงษ์วิทยากร"
                                since="ปี พ.ศ. 2550 - 2551"
                                img="https://arch.mju.ac.th/img/Personal/E1054.jpg"
                            />
                        </div>
                    </div>
                </div>
            );
        } else if (page && page === "contact") {
            return (
                <div id="core" className="">
                    <div className=" col-12 col-md-10 px-md-5 px-2 mb-4 align-content-center mx-auto">
                        <h1 style={{ marginTop: "30px" }}>ติดต่อเรา</h1>
                        <div className="row row-cols-1 row-cols-lg-2 justify-content-center text-center">
                            <CardAddress
                                title="ที่อยู่ทางไปรษณีย์"
                                address="คณะสถาปัตยกรรมศาสตร์และการออกแบบสิ่งแวดล้อม มหาวิทยาลัยแม่โจ้"
                                address2="เลขที่ 63 หมู่ 4 ถนนเชียงใหม่-พร้าว"
                                address3="ตำบลหนองหาร อำเภอสันทราย จังหวัดเชียงใหม่ 50290"
                            />
                            <CardAddress
                                title="Postal Address"
                                address="Faculty of Architecture and Environmental Design, Maejo University"
                                address2="63 Moo.4, Sansai-Phrao Road, Nongharn"
                                address3="Sansai District, Chiang Mai, 50290 Thailand"
                            />
                            <CardAddress
                                title="ติดต่อ"
                                tel="0 5387 5350"
                                fax="0 5387 5355"
                                email="Archmaejo@Gmail.com"
                                facebook="ArchMaejo"
                            />
                        </div>
                        <div className="maplocation">
                            Google Maps
                            <iframe
                                src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d1498.032408147062!2d99.01518742407033!3d18.895726655720726!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x30da234ae97f126f%3A0xbae7635fee77413!2z4LiE4LiT4Liw4Liq4LiW4Liy4Lib4Lix4LiV4Lii4LiB4Lij4Lij4Lih4Lio4Liy4Liq4LiV4Lij4LmM4LmB4Lil4Liw4LiB4Liy4Lij4Lit4Lit4LiB4LmB4Lia4Lia4Liq4Li04LmI4LiH4LmB4Lin4LiU4Lil4LmJ4Lit4LihIOC4oeC4q-C4suC4p-C4tOC4l-C4ouC4suC4peC4seC4ouC5geC4oeC5iOC5guC4iOC5iQ!5e0!3m2!1sth!2sth!4v1728290011222!5m2!1sth!2sth"
                                title="arch@maejo map"
                                width="100%"
                                height="500"
                                style={{ border: "4px dark solid" }}
                                allowfullscreen=""
                                loading="lazy"
                                referrerpolicy="no-referrer-when-downgrade"
                            ></iframe>
                        </div>
                    </div>
                </div>
            );
        } else {
            navigate("/about/", { replace: true });
        }
    };

    return pageHistory();
}
